import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Inicio from './pages/Inicio/Inicio';
import Login from './pages/Login/Login';
import Home from './pages/Home/Home';
import Empresa from "./pages/Empresa/Empresa";
import Sucursal from "./pages/Sucursal/Sucursal";
import Tarifas from "./pages/Tarifas/Tarifas";
import Empleado from "./pages/Empleado/Empleado";
import Estadistica from "./pages/Estadistica/Estadistica";
import Recaudaciones from "./pages/Recaudaciones/Recaudaciones";
import Control from "./pages/Control/Control";
import ProtectedRoute from './Proteccion/ProtectedRoute';
import MainLayout from "./components/MainLayout";
import Encuesta from "./pages/Encuesta/Encuesta";
import RegistroParqueadero from "./pages/RegistroParqueadero/RegistroParqueadero";
import EditarParqueadero from "./pages/EditarParqueadero/EditarParqueadero";
import Membresias from "./pages/Membresias/Membresias";
import Clientes from "./pages/Clientes/Clientes";
import Calendario from "./pages/Calendario/Calendario";
import TiposTarifa from "./pages/TiposTarifa/TiposTarifa";

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta pública para Login */}
        <Route path="/" element={<Inicio />} />
        <Route path="/login" element={<Login />} />
        <Route path="/encuesta" element={<Encuesta />} />
        <Route path="/registro-parqueadero" element={<RegistroParqueadero />} />
        <Route path="/editar-parqueadero" element={<EditarParqueadero />} />

        {/* Rutas protegidas: MainLayout + Outlet */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {/* Rutas hijas que usarán el mismo menú y cabecera */}
          <Route path="home" element={<Home />} />
          <Route path="empresa" element={<Empresa />} />
          <Route path="sucursal" element={<Sucursal />} />
          <Route path="tarifas" element={<Tarifas />} />
          <Route path="empleado" element={<Empleado />} />
          <Route path="recaudaciones" element={<Recaudaciones />} />
          <Route path="estadistica" element={<Estadistica />} />
          <Route path="control" element={<Control />} />     
          <Route path="membresias" element={<Membresias />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="calendario" element={<Calendario />} />
          <Route path="tipos-tarifa" element={<TiposTarifa />} />
        </Route>

        {/* Página 404 (opcional) */}
        <Route path="*" element={<h1>404 - Página no encontrada</h1>} />
      </Routes>
    </Router>
  );
}

export default App;
